import React, { useState } from 'react';
import type { TradeBriefingSpeciesSpec, TradeBriefingStructureScope } from '../../types';

function structureTitle(structure: TradeBriefingStructureScope): string {
  if (structure.quantity && structure.quantity > 1) {
    return `${structure.name} ×${structure.quantity}`;
  }
  return structure.name;
}

function speciesLine(
  specs?: TradeBriefingSpeciesSpec[],
  labels?: string[],
): string {
  if (specs?.length) {
    return specs
      .map(spec => [spec.species, spec.grade, spec.dryness].filter(Boolean).join(' · '))
      .filter(Boolean)
      .join(', ');
  }
  return (labels || []).filter(Boolean).join(', ');
}

const StructureImage: React.FC<{ url: string; name: string }> = ({ url, name }) => {
  const [failed, setFailed] = useState(false);
  if (failed) return <div className="tb-structure-card-media" aria-hidden />;
  return (
    <div className="tb-structure-card-media">
      <img src={url} alt={name} onError={() => setFailed(true)} />
    </div>
  );
};

type TradeBriefingStructureCardsProps = {
  structures: TradeBriefingStructureScope[];
  modelCaption?: string;
};

const TradeBriefingStructureCards: React.FC<TradeBriefingStructureCardsProps> = ({
  structures,
  modelCaption = 'These structures are in the 3D model above.',
}) => {
  if (!structures.length) return null;

  return (
    <div className="tb-structures">
      <div className="tb-structures-head">
        <p className="tb-kicker">In the model</p>
        <h3>Structures</h3>
        <p className="tb-structures-note">{modelCaption}</p>
      </div>
      <ul className="tb-structure-grid">
        {structures.map(structure => {
          const photo = structure.images?.[0];
          const meta = speciesLine(structure.speciesSpecs, structure.speciesLabels);
          return (
            <li key={structure.id} className="tb-structure-card">
              {photo?.url ? (
                <StructureImage url={photo.url} name={photo.name || structure.name} />
              ) : (
                <div className="tb-structure-card-media" aria-hidden />
              )}
              <div>
                <h3>{structureTitle(structure)}</h3>
                {meta ? <p>{meta}</p> : null}
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default TradeBriefingStructureCards;
